export default "__VITE_ASSET__bd7c4aeb__"